












import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ErrorBar extends Vue {
	get errorText() {
		return this.$store.getters.errorText;
	}
}
